import { jsx } from "react/jsx-runtime";
import { isCallState, isOutputState } from "./types.js";
import { toolOutputToFeaturedProduct } from "./utils.js";
import { FeaturedProductWidget } from "../FeaturedProductWidget.js";
function FeaturedProductPart({
  part,
  allParts
}) {
  const suppressOutput = allParts.some((p) => p.type === "data-pdp-product-info");
  const output = part.output;
  if (isCallState(part.state)) return null;
  if (suppressOutput) return null;
  if (isOutputState(part.state) && output && !output.error) {
    const product = toolOutputToFeaturedProduct(output);
    return /* @__PURE__ */ jsx(FeaturedProductWidget, { product });
  }
  return null;
}
export {
  FeaturedProductPart
};
//# sourceMappingURL=FeaturedProductPart.js.map
